export default __webpack_public_path__ + "static/8-tips-for-saving-money-for-your-next-holiday-goals-2978042c3700f6dea0823bdbd1f713ac.jpg";